import {
  Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef
} from '@angular/core';

import { CustomerService } from 'modules/core/services/customer.service';

import { SnackbarService } from 'app/services/snackbar.service';

@Component({
  selector: 'artemis-customers-batch-upload',
  templateUrl: './customers-batch-upload.component.html',
  styleUrls: ['./customers-batch-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomersBatchUploadComponent implements OnInit {

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>;

  @Input() isFileProcessing: boolean = false;

  @Output() processFile: EventEmitter<File> = new EventEmitter();

  readonly allowedFileFormats: string = '.xlsx, .xls, .csv';

  selectedFile: File;

  constructor(private cdRef: ChangeDetectorRef,
              private customerService: CustomerService,
              private snackbar: SnackbarService) { }

  ngOnInit() {
  }

  /**
   * @method fileUploadedChange
   * Handles file uploaded with bunch upload permissions
   */
  fileUploadedChange(event: FileList): void {
    if (event.length > 0) {
      this.selectedFile = event.item(0);
      this.cdRef.detectChanges();
    }
  }

  /**
   * @method batchUpload
   * Upload file to server
   */
  batchUpload(): void {
    if (!this.selectedFile) {
      this.snackbar.error('No file selected');
    } else {
      this.processFile.next(this.selectedFile);
    }
  }

  clearUpload(): void {
    this.selectedFile = undefined;
    this.fileInput.nativeElement.value = '';
    this.cdRef.detectChanges();
  }

  getCustomersBatchUploadTemplate(): void {
    this.customerService.getCustomersBatchUploadTemplate()
      .subscribe(
        (res: Blob) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement('a');
          const fileName = `customer batch upload template.xlsx`;

          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        },
        (error: any) => {
          this.snackbar.error('Error: Failed to download batch upload template. Please try again later.');
        }
      );
  }
}
